import axios from 'axios';

export const updateFolder = async (folder) => {
  const url = `${process.env.REACT_APP_API_URL}/folders/${folder.id}`;
  const headers = {
    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    'Content-Type': 'application/json'
  };
  try {
    const response = await axios.put(url,{...folder},{headers: headers});
    return response;
  } catch (error) {
    const {response} = error;
    return response;
  }
}


